import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDsoGroupList } from '../../../../../actions/dsosActions';
import { Combobox } from '../../../../commonComponents/Combobox/Combobox';

export const GroupFilter = ({ dsoId, filters, onChange }) => {
  const dispatch = useDispatch();

  const {
    data,
    filters: groupOptionsFilters,
    total,
  } = useSelector((state) => state.dsos.dsoGroupList);

  const options = useMemo(
    () =>
      data.map((it) => ({
        label: it.name,
        value: it.id,
      })),
    [data],
  );

  useEffect(() => {
    if (dsoId) {
      dispatch(fetchDsoGroupList(dsoId, { page: 1 }, true));
    }
  }, [dispatch, dsoId]);

  return (
    <Combobox
      isDisabled={!dsoId}
      hasReachMax={total === data.length}
      isAutoApply
      isPaged
      label="Group:"
      options={options}
      placeholder="All"
      values={options?.find((it) => it.value === filters.groupId) || []}
      onChange={(values) => {
        onChange('groupId', values?.value);
      }}
      onNextPage={() => {
        dispatch(fetchDsoGroupList(dsoId, { page: groupOptionsFilters.page + 1 }));
      }}
    />
  );
};
